import 'react-app-polyfill/ie9';
import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
//PAGES
import Routes from './routes'
import ABRoutes from './abtesting/routes'


import API from './api'

import DOTENV from './env.json';


import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import PageTransition from "react-router-page-transition";
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import reducers from './store/reducers'
import { UI, General } from './store/actions'
// import LoadingScreen from './views/layout/LoadingScreen'
import 'bootstrap/dist/css/bootstrap.min.css';

import { composeWithDevTools } from 'redux-devtools-extension';
import { sessionService } from 'redux-react-session';
// import PrivateRoute from './PrivateRoute'
// import ABRoute from './ABRoute'

import Load3rdPartyScripts from './load3rdPartyScripts'

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
const store = createStore(reducers, composeWithDevTools())

const PrivateRoute = React.lazy(() => import('./PrivateRoute'));
const ABRoute = React.lazy(() => import('./ABRoute'));
const Layout = React.lazy(() => import('./views/layout/Layout'));
const ExternalRedirect = React.lazy(() => import('./views/pages/ExternalRedirect'));
const LoadingScreen = React.lazy(() => import('./views/layout/LoadingScreen'));

const validateSession = (session) => {
    // // check if your session is still valid
    // console.log('[SESSION]Validate',session.token.user_id)
    // return api.auth.validateSession(session.token.user_id,session.token.id).then( (response) => {
    //     console.log('[SESSION]Response',response)
    //     return response.isValid;
    // })
    // console.log('VARIABLES DE SESION',session.token)
    //FORCE LOGOUT OF EDGAR CHAVIRA(BODEGABLE)
    if (session.token.user_id == 214) return false;
    return true;
}
const options = { refreshOnCheckAuth: true, redirectPath: '/login', driver: 'COOKIES', validateSession };

// sessionService.initSessionService(store,options);

store.dispatch(UI.setMenuCurrentPage('home'))
store.dispatch(UI.setLoading(false))


const api = new API();

// const PrivateRoute = ({ component: Component, ...rest }) => (
//     <Route {...rest} render={(props) => (
//       fakeAuth.isAuthenticated === true
//         ? <Component {...props} />
//         : <Redirect href='/login' />
//     )} />
//   )

Load3rdPartyScripts.GoogleFonts();
Load3rdPartyScripts.GoogleMaps();

sessionService.initSessionService(store, options).then((response) => {
    console.log('[SESSION]Response', response)
    var user = store.getState().session.user;
    if (user.id != null) {
        // console.log('IDENTIFY FUNC',window.mixpanel.identify)
        window.mixpanel.identify(user.id)
        console.log('[MIXPANEL] IDENTIFY USER', user.id)
    }
    api.catalog.getAll().then((catalogs) => {

        store.dispatch(General.setCatalogs(catalogs.catalogs));
        console.log('[ABROUTE] => Add Menu')
        store.dispatch(UI.showMenu(true));
        if (window.location.origin == "https://mubit.co" || window.location.origin == "https://www.mubit.co") {
            Sentry.init({
                dsn: "https://e0aaadcba58a402ab8bb306d8ad78fd3@o640814.ingest.sentry.io/5757277",
                integrations: [new Integrations.BrowserTracing()],

                // Set tracesSampleRate to 1.0 to capture 100%
                // of transactions for performance monitoring.
                // We recommend adjusting this value in production
                tracesSampleRate: 0.8,
            });
        }

        fetch('https://api.mubit.co/api/v2/catalogs/wati-following/', {
            // fetch('http://mubit.lab/psp/api/v2/catalogs/wati-following/',{
            method: 'GET',
            headers: {
                // 'Access-Control-Allow-Origin':'*,Access-Control-Allow-Origin ',
                'Accept': '*/*',
                'Host': 'api.mubit.co',
            }
        }).then(response => response.json()).then(json => {
            store.dispatch(General.setCampaigns(json.products));
        });

        ////console.log('SESSION LOADED')
        ReactDOM.render(
            <Provider store={store}>
                <Suspense fallback={<div>Cargando...</div>}>
                    <LoadingScreen />

                    <Router >

                        <Layout>
                            <Switch>
                                <ABRoute site={'home'} path={'/'} exact
                                    components={
                                        [
                                            {
                                                component: ExternalRedirect,
                                                percentage: 100,
                                                variation: 'redirect-home',
                                                redirect_url: 'https://www.mubit.co/'
                                            }
                                        ]
                                    }
                                />
                                <Route exact path={Routes.LandingWixOne.url} component={Routes.LandingWixOne.component} />
                                <Route exact path={'/landing-home'} component={Routes.nuevaLanding.component} />

                                <Route exact path={'/almacen'} component={Routes.nuevaLanding.component} />
                                <Route exact path={Routes.Hashogin.url} component={Routes.Hashogin.component} />
                                <Route exact path={Routes.GraciasFormularios.url} component={Routes.GraciasFormularios.component} />
                                <Route exact path={Routes.GraciasMubitExpress.url} component={Routes.GraciasMubitExpress.component} />
                                <Route exact path={Routes.GraciasMubitFinal.url} component={Routes.GraciasMubitFinal.component} />
                                <Route exact path={Routes.GraciasMubitNosotros.url} component={Routes.GraciasMubitNosotros.component} />
                                <Route exact path={Routes.GraciasMubitInicio.url} component={Routes.GraciasMubitInicio.component} />
                                <Route path={Routes.NewRequest.url} component={Routes.NewRequest.component} />
                                <Route path={Routes.NewRequest2.url} component={Routes.NewRequest2.component} />
                                <Route path={Routes.CotizaAsesor.url} component={Routes.CotizaAsesor.component} />
                                <Route path={Routes.Login.url} component={Routes.Login.component} />
                                <Route path={Routes.Registrate.url} component={Routes.Registrate.component} />
                                <Route path={Routes.Terms.url} component={Routes.Terms.component} />
                                <Route path={Routes.AvisoPrivacidad.url} component={Routes.AvisoPrivacidad.component} />
                                <Route path={Routes.Contacto.url} component={Routes.Contacto.component} />
                                <Route path={Routes.Cotizacion.url + ":id"} component={Routes.Cotizacion.component} exact />
                                <Route path={Routes.CotizacionB.url + ":id"} component={Routes.CotizacionB.component} exact />
                                <Route path={Routes.CotizacionLibre.url + ":id"} component={Routes.CotizacionLibre.component} exact />
                                <Route path={Routes.CotizacionV2.url + ":id"} component={Routes.CotizacionV2.component} exact />
                                <Route path={Routes.Cookies.url} component={Routes.Cookies.component} />
                                <Route path={Routes.ReceiptPaid.url} component={Routes.ReceiptPaid.component} />
                                <Route path={Routes.RequestPasswordRecover.url} component={Routes.RequestPasswordRecover.component} />
                                <Route path={Routes.PasswordRecover.url} component={Routes.PasswordRecover.component} />
                                <Route path={Routes.SolicitudPago.url + ":id"} component={Routes.SolicitudPago.component} />
                                <Route path={Routes.SolicitudPagoV2.url + ":id"} component={Routes.SolicitudPagoV2.component} />
                                <Route path={Routes.SolicitudPagoV3.url + ":id"} component={Routes.SolicitudPagoV3.component} />
                                <Route path={Routes.Authologin.url + ":id"} component={Routes.Authologin.component} />
                                <Route path={Routes.InventarioListo.url} component={Routes.InventarioListo.component} />

                                <Route path={Routes.EntregaBodega.url + ":id"} component={Routes.EntregaBodega.component} exact />

                                <Route path="/mi-cuenta"
                                    render={({ match: { url } }) => (
                                        <>
                                            <PrivateRoute path={`${url}/perfil`} component={Routes.Perfil.component} />
                                            <PrivateRoute path={`${url}/inventario`} component={Routes.Inventarios.component} />
                                            <PrivateRoute path={`${url}/inventario-si`} component={Routes.InventariosSI.component} />
                                            <PrivateRoute path={`${url}/facturacion`} component={Routes.Facturacion.component} />
                                            <PrivateRoute path={`${url}/entregas`} component={Routes.Entregas.component} />
                                            <PrivateRoute path={`${url}/quedarme-un-mes-mas/:id`} component={Routes.QuedarmeUnMesMas.component} />
                                            <PrivateRoute path={`${url}/confirmar-cita-old/:id`} component={Routes.ConfirmarCita.component} />
                                            <PrivateRoute path={`${url}/confirmar-cita/:id`} component={Routes.ConfirmarCitaV2.component} />
                                            <PrivateRoute path={`${url}/cita-confirmada/gracias/:id`} component={Routes.Gracias.component} />
                                            <PrivateRoute path={`${url}/confirmar-entrega/:id`} component={Routes.ConfirmarEntrega.component} />
                                            <PrivateRoute path={`${url}/adeudo`} component={Routes.Adeudo.component} />
                                            <PrivateRoute path={`${url}/pagos`} component={Routes.Pagos.component} />
                                            <PrivateRoute path={`${url}/recibo/:ids`} component={Routes.Recibo.component} />
                                        </>
                                    )}
                                />

                                <Route component={Redirect} />
                            </Switch>

                        </Layout>

                    </Router>
                </Suspense>


            </Provider>,
            document.getElementById('root'));
    })
})



